import { render, staticRenderFns } from "./CustomerLogos.vue?vue&type=template&id=e3f1143a&scoped=true"
import script from "./CustomerLogos.vue?vue&type=script&lang=js"
export * from "./CustomerLogos.vue?vue&type=script&lang=js"
import style0 from "./CustomerLogos.vue?vue&type=style&index=0&id=e3f1143a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f1143a",
  null
  
)

export default component.exports